import React from 'react';
import styled from 'styled-components';
import ModuleContext from 'CMFW/context/ModuleContext';
import VocCard from './VocCard';
import PanelCard from './PanelCard';
import CulturalVocCard from './CulturalVocCard';
import CompoundCard from './CompoundCard';
import { IRefIds } from 'constants/refs';

interface IProps {
  conceptRef: number;
  refId: number;
  courseId: number;
  className?: string;
}

const ConceptCard: React.FC<IProps> = ({ conceptRef, refId, courseId, className }) => {

  const renderCard = () => {
    // For vocabulary, use VocCard
    if (conceptRef === IRefIds.vocs) {
      return (
        <ModuleContext.Provider value={{ courseId } as any}>
          <VocCard id={refId} />
        </ModuleContext.Provider>
      );
    }

    // For panels, use PanelCard
    if (conceptRef === IRefIds.panels) {
      return (
        <ModuleContext.Provider value={{ courseId } as any}>
          <PanelCard id={refId} />
        </ModuleContext.Provider>
      );
    }

    // For cultural vocabulary, use CulturalVocCard
    if (conceptRef === IRefIds.cultural) {
      return (
        <ModuleContext.Provider value={{ courseId } as any}>
          <CulturalVocCard id={refId} />
        </ModuleContext.Provider>
      );
    }

    // For compounds, use CompoundCard
    if (conceptRef === IRefIds.compounds) {
      return (
        <ModuleContext.Provider value={{ courseId } as any}>
          <CompoundCard id={refId} />
        </ModuleContext.Provider>
      );
    }

    // Fallback
    return (
      <FallbackCard>
        <div>Unknown concept type</div>
        <div>
          Ref: {conceptRef}, ID: {refId}
        </div>
      </FallbackCard>
    );
  };

  return <div className={className}>{renderCard()}</div>;
};

export default ConceptCard;

const FallbackCard = styled.div`
  padding: 16px;
  background: #f5f5f5;
  border-radius: 4px;
  font-size: 14px;
  color: #666;
`;
